import React, { useState, useEffect } from "react";
import {
  Steps,
  Button,
  Form,
  Input,
  message,
  Radio,
  Flex,
  Card,
  Row,
  Col,
  Tag,
  Divider,
} from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import {
  GoogleOutlined,
  EyeTwoTone,
  GooglePlusOutlined,
} from "@ant-design/icons";
import googleicon from "../Assets/Onboardingimages/googleicon.png";
import applelogo from "../Assets/Onboardingimages/applelogo.png";

import { URL } from "../helper/Mainurl";
import axios from "axios";
import { HeaderSection } from "./HeaderSection";
import { FooterSection } from "./FooterSection";

const SignUpwithGoogle = () => {
  const token = localStorage.getItem("authToken"); // Get token from localStorage

  const [form] = Form.useForm();
  const [initialEmail, setInitialEmail] = useState("");
  const [viewProfile, setViewProfile] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const { invite_email, invite_id } = location.state || {}; // Get data

  // console.log("invite_email:::::::::::::",invite_email)

  const handleContinue = () => {
    form.validateFields(["email"]).then((values) => {
      navigate("/signup", {
        state: {
          email: values.email,
          invite_email, // Pass invite email
          invite_id, // Pass invite id
          normalSignup: true,
        },
      });
    });
  };

  const handleGoogleLogin = async () => {
    console.log("url:::::::::::", `${URL}/v1/auth/google/redirect`);
    try {
      window.location.href = `${URL}/v1/auth/google/redirect`;
    } catch (error) {
      console.log("error", error);
    }
  };
  useEffect(() => {
    if (viewProfile && token) {
      navigate("/profile"); // Redirect to profile if viewProfile is true
    }
  }, [viewProfile, navigate]);

  useEffect(() => {
    if (invite_email) {
      setInitialEmail(invite_email);
    }
  }, [invite_email]);

  useEffect(() => {
    if (initialEmail) {
      form.setFieldsValue({ email: initialEmail });
    }
  }, [initialEmail, form]);

  const emailValue = (e) => {
    if (!invite_email) {
      // Allow editing only if invite_email is not set
      setInitialEmail(e.target.value);
    }
  };

  return (
    <div style={{ height: "100%", overflow: "auto" }}>
      <HeaderSection />
      <div className="scrollable-content">
        <div className="login-page">
          <div className="login-image">
            <img src="/quelld-signup.png" className="login-image" />
          </div>

          <div>
            <div className="login-heading">
              Sign up to achieve more
            </div>
            <div className="login-subtext">
              Curious about how to boost your productivity and achieve your
              goals? Sign up now and find out!
            </div>

            <div className="login-form">
              <Form form={form} layout="vertical">
                <Form.Item
                  name="email"
                  rules={[
                    { required: true, message: "Please enter your email!" },
                    {
                      pattern:
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                      message: "Please enter a valid email address!",
                    },
                  ]}
                >
                  <div className="floating-label">
                    <Input
                      placeholder=" "
                      // onChange={emailValue}
                      id="googleEmail"
                      style={{height: '40px'}}
                      value={initialEmail}
                      disabled={!!invite_email} // Disable input if invite email exists
                      onChange={(e) =>
                        !invite_email && setInitialEmail(e.target.value)
                      } // Allow editing only if there's no invite email
                    />
                    <label htmlFor="googleEmail">Email</label>
                  </div>
                </Form.Item>
                <Button
                  type="primary"
                  onClick={() => handleContinue(form.getFieldsValue())}
                  className="login-primary-action"
                >
                  Continue
                </Button>
              </Form>
            </div>
            <div style={{ marginTop: "32px", marginBottom: "32px" }}>
              <Divider className="or-divider">
                <div style={{ fontSize: "12px", color: "#767A83" }}>
                  Or Sign up with
                </div>
              </Divider>
            </div>
            <div>
              <Button
                className="social-button-google"
                onClick={handleGoogleLogin}
              >
                <img src={googleicon} width={16} /> Google
              </Button>
            </div>
            {/* <Button className="social-button-google"  >
              <img src={applelogo} width={16} /> Apple
            </Button> */}
          </div>
          <div
            style={{
              color: "#767A83",
              fontSize: "14px",
              justifyContent: "center",
              display: "flex",
              marginTop: "32px",
              marginBottom: "32px",
            }}
          >
            Have an account?{" "}
            <a
              href="/"
              style={{
                color: "#9A4FE0",
                paddingLeft: "3px",
                textDecoration: "none",
                fontWeight: "500",
              }}
            >
              {" "}
              Sign in now!
            </a>
          </div>
        </div>
      </div>
      <FooterSection />
    </div>
  );
};
export default SignUpwithGoogle;
